module.exports = __webpack_public_path__ + "static/media/alertIcon.bd22f268.svg";